import React, { Fragment,useContext,useState } from "react";
import DataTable from "react-data-table-component";
import { DropdownItem } from "reactstrap";
import ActionOptions from "../Common/Component/ActionOptions";
import moment from "moment";
import { corporateClientColumns } from "../../Data/Configuration/CorporateClient";
import { Spinner } from "../../AbstractElements";
import DeleteConfirmation from "./DeleteConfirmation";
import CustomizerContext from "../../_helper/Customizer";

const CorporateClientTable = ({
    tableData,
    setShowApiLoader,
    fetchTableData,
    paginationPerPage,
    paginationTotalRows,
    onChangePage,
    onChangeRowsPerPage,
    onEditClick,
    loader,
    editId,
    setEditId
}) => {
    const [deleteModal, setDeleteModal] = useState(false);
    const toggleDeleteModal = () =>
        setDeleteModal(!deleteModal);

    const {mix_background_layout} = useContext(CustomizerContext)

    const processData = tableData.map((element, index) => {
        return {
            companyName: element.companyName ? element.companyName : "-",
            a2c: element.a2c ? "true" : "false",
            c2a: element.c2a ? "true" : "false",
            contactPerson: element.contactPerson ? element.contactPerson : "-",
            email: element.email ? element.email : "-",
            mobile: element.mobile ? element.mobile : "-",
            // addressLine: element.addressLine ? element.addressLine : "-",
            city: element.city ? element.city : "-",
            isMegaCabsCompany: element.isMegaCabsCompany ? "true" : "false",
            createdOn: element.createdOn
                ? moment(new Date(element.createdOn)).format("MMM DD HH:mm")
                : "-",
            airportCharge: element.airportCharge || element.airportCharge == 0 ? element.airportCharge : "-",
            action: (
                <ActionOptions key={index}>
                    <Fragment>
                        <DropdownItem
                            className="border-0"
                            key={"row-edit"}
                            onClick={() => onEditClick(element)}
                        >
                            <i className="fa fa-pencil"></i> Edit
                        </DropdownItem>
                        <DropdownItem
                            className="border-0"
                            key={"row-edit"}
                            onClick={() => {
                                setEditId(element?.id)
                                toggleDeleteModal()
                            }}
                        >
                            <i className="fa fa-trash-o"></i> Delete
                        </DropdownItem>
                    </Fragment>
                </ActionOptions>
            ),
        };
    });
    return (
        <Fragment>
            <div className="table-responsive corporate-client-table">
                <DataTable
                    columns={corporateClientColumns}
                    data={processData}
                    center={true}
                    fixedHeader
                    fixedHeaderScrollHeight={"57vh"}
                    pagination
                    paginationPerPage={paginationPerPage}
                    paginationTotalRows={paginationTotalRows}
                    onChangePage={onChangePage}
                    onChangeRowsPerPage={onChangeRowsPerPage}
                    // customStyles={customStyles}
                    paginationServer
                    progressPending={loader}
                    progressComponent={<div className="loader-box" style={{ height: "57vh" }}>
                        <Spinner attrSpinner={{ className: "loader-3", style: { width: "30px", height: "30px", borderColor: "#39B54A", borderBottomColor: "transparent" } }} />
                    </div>}
                    theme={mix_background_layout == "dark-only" ? "dark" : "default"}
                />
            </div>
            <DeleteConfirmation
                LargeModaltoggle={toggleDeleteModal}
                title={"Delete"}
                Large={deleteModal}
                deleteId={editId}
                fetchData={fetchTableData}
            />

        </Fragment>
    );
};

export default CorporateClientTable;
